import {Component, OnInit} from '@angular/core';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import {ModalService} from '../../../service/modal.service';
import {GlobalService} from '../../../service/global.service';
import {ItemConfiguracao} from '../../../model/catalogo';
import {PesquisasFiltroApiService} from '../../../service/api/pesquisas-filtro.api';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'item-configuracao-modal',
    templateUrl: './item-configuracao-modal.component.html'
})
export class ItemConfiguracaoModalComponent {

    constructor(private globalService: GlobalService, public modalService: ModalService, public pesquisaService: PesquisasFiltroApiService, private formBuilder: FormBuilder, private route: ActivatedRoute) {
    }

    private sub: any;

    pagina: number = 1;
    qtdPorPagina: number = 7;
    totalPaginas: number = 1;

    campoBusca = new FormControl('', []);
    selecionaAutomatico: boolean = false;
    resultado: Array<ItemConfiguracao> = null;
    visiveis: Array<ItemConfiguracao> = null;
    selecionado: ItemConfiguracao = null;
    tipoItemConfiguracao: string = '';
    mensagemErro: string = '';

    itemConfiguracaoModalForm: FormGroup = this.formBuilder.group({
        campoBusca: this.campoBusca,
    });

    ngOnInit() {
        this.mensagemErro = '';
        this.campoBusca.setValue('');
        this.selecionaAutomatico = false;

        this.sub = this.route
            .queryParams
            .subscribe(params => {
                // Defaults to 0 if no query param provided.
                if (params['campoBusca'] != '') {
                    this.campoBusca.setValue(params['campoBusca']);
                }
                if (params['selecionaAutomatico'] != '') {
                    this.selecionaAutomatico = params['selecionaAutomatico'];
                }
                if (params['tipoItemConfiguracao'] != '') {
                    this.tipoItemConfiguracao = params['tipoItemConfiguracao'];
                }
                this.pesquisar();
            });
    }

    pesquisar() {
        this.resultado = new Array<ItemConfiguracao>();
        this.visiveis = new Array<ItemConfiguracao>();
        let filtros: Array<any> = new Array<any>();
        filtros.push({
            'filtroItemConfiguracao': {
                'nomeItemConfiguracao': this.campoBusca.value,
                'tipoItemConfiguracao': this.tipoItemConfiguracao
            }
        });
        this.pesquisaService.filtraItemConfiguracao(filtros)
            .subscribe(
                listaItens => {
                    this.resultado = listaItens as Array<ItemConfiguracao>;
                    this.mudarPagina(1, 'false');
                },
                erro => {
                    if (erro.status == 404) {

                    }
                }
            );
    }

    selecionaInstalacao(IC: ItemConfiguracao) {
        this.selecionado = IC as ItemConfiguracao;
    }

    mudarPagina(pag: number, desabilitado: string) {

        if (desabilitado == 'true') {
            return false;
        }

        this.pagina = pag;
        this.visiveis = new Array<ItemConfiguracao>();
        let ind = 1;
        this.resultado.forEach(res => {
            if (ind > (pag - 1) * this.qtdPorPagina && ind <= pag * this.qtdPorPagina) {
                this.visiveis.push(res);
            }
            ind++;
        });
    }

    confirmar() {
        if (this.selecionado == null) {
            this.mensagemErro = 'Selecione o Item de Configuração ou clique em \'Fechar\'';
        } else {
            this.modalService.incluirDadosGerados(this.selecionado);
            this.modalService.fecharPaginaModal();
        }
    }

    cancelar() {
        this.modalService.fecharPaginaModal();
    }

}



// WEBPACK FOOTER //
// ./src/app/modal/item-configuracao-modal/item-configuracao-modal.component.ts